import React from "react";
import ContactForm from '../components/ContactForm';
import './Contact.css';
import emailIcon from '../logos/email-icon.png';
import clockIcon from '../logos/clock-icon.png';

const Contact = () => {
    return (
        <div className="contact-page-container">
            {/* Left Content */}
            <div className="contact-page-left">
                <h1 className="contact-page-header">Contact Us</h1>

                <div className="contact-page-info">
                    <div className="contact-page-item">
                        <img src={emailIcon} alt="Contact Details" className="contact-page-icon" />
                        <div>
                            <h3 className='contact-page-subheader'>Send Us An Email</h3>
                            <p className='contact-page-text'>support@toptierbenefits.com</p>
                        </div>
                    </div>
                    <div className="contact-page-item">
                        <img src={clockIcon} alt="Additional Notes" className="contact-page-icon" />
                        <div>
                            <h3 className='contact-page-subheader'>Mon-Fri</h3>
                            <p className='contact-page-text'>8Am to 6Pm (CST)</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Content: Contact Form */}
            <div className="contact-page-right">
                <ContactForm />
            </div>
        </div>
    );
};

export default Contact;
